module.exports = __webpack_public_path__ + "static/Case-Studies-Sircles-c8cbd5b1f2d882cacee2d5b5468111de.jpeg";